import { BreadcrumbItem } from "@/types/breadcrumb";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSettlementsDetailsBreadcrumb } from "@/modules/projects/components/settlementsDetails/hooks/useSettlementsDetailsBreadcrumb";
import { ProjectSettlementService } from "@/modules/projectSettlements/service/projectSettlements";
import { Module } from "@/constants";

interface InvoiceSpecificationsBreadcrumbsCreatorProps {
  projectId: string | undefined;
  settlementId: string | undefined;
}

export const useInvoiceSpecificationsCreatorBreadcrumbs = ({
  projectId,
  settlementId,
}: InvoiceSpecificationsBreadcrumbsCreatorProps): BreadcrumbItem[] => {
  const { t } = useTranslation();

  const settlementQuery = useQuery({
    queryKey: [Module.ProjectSettlements, settlementId] as const,
    queryFn: () => ProjectSettlementService.get(settlementId),
  });

  // Get the settlements breadcrumb
  const settlementsBreadcrumbs = useSettlementsDetailsBreadcrumb({
    projectId,
    settlementId,
    settlementQuery,
  });

  // Create the invoice specification breadcrumb item
  const invoiceSpecificationBreadcrumbItem = useMemo(() => {
    return {
      label: t("projectInvoiceSpecifications.title.create"),
    };
  }, [t]);

  // Append the invoice specification breadcrumb to the settlements breadcrumbs
  return [...settlementsBreadcrumbs, invoiceSpecificationBreadcrumbItem];
};
